import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from 'domain/router/router';

// v7_startTransition: true - https://github.com/remix-run/react-router/releases/tag/react-router%406.13.0

const RootRoute = () => <RouterProvider router={router} future={{ v7_startTransition: true }} />;

export default RootRoute;
